/** Resolve com o elemento quando ele existir, ou `null` depois de `ms`. */
export function esperarElemento(seletor: string, ms = 6000): Promise<Element | null> {
  return new Promise((resolve) => {
    const agora = document.querySelector(seletor)
    if (agora) return resolve(agora)
    const obs = new MutationObserver(() => {
      const el = document.querySelector(seletor)
      if (el) fim(el)
    })
    const timer = window.setTimeout(() => fim(null), ms)
    function fim(el: Element | null) {
      obs.disconnect()
      window.clearTimeout(timer)
      resolve(el)
    }
    obs.observe(document.body, { childList: true, subtree: true })
  })
}

/** Resolve quando o seletor some da tela (ou depois de `ms`). */
export function esperarSumir(seletor: string, ms = 120000): Promise<void> {
  return new Promise((resolve) => {
    if (!document.querySelector(seletor)) return resolve()
    const obs = new MutationObserver(() => {
      if (!document.querySelector(seletor)) fim()
    })
    const timer = window.setTimeout(fim, ms)
    function fim() {
      obs.disconnect()
      window.clearTimeout(timer)
      resolve()
    }
    obs.observe(document.body, { childList: true, subtree: true })
  })
}
